import { useNavigate } from 'react-router';
import dynamicfunction from '../../utils/dynamicfunction';
import { getContentKeyAccToLang } from '../../utils/utils';
import { useSelector } from 'react-redux';

export default () => {
  const navigate = useNavigate();
    const { TextWeight, isArabic } = dynamicfunction();

    const authContent = useSelector((state) => state.content?.authContent);
  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      authContent?.web_onboarding?.data?.attributes,
      key,
      isArabic
    );
  };
  

  return { TextWeight, navigate, getContentKey, isArabic };
};
